import SvgIcon from '@material-ui/core/SvgIcon';
import cx from 'classnames';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  icon: PropTypes.node,
  active: PropTypes.bool,
  completed: PropTypes.bool,
  error: PropTypes.bool,
};

const defaultProps = {
  className: null,
  classes: null,
  icon: null,
  active: false,
  completed: false,
  error: false,
};

const WizardStepperIcon = ({ className, classes, icon, active, completed, error }) => {
  const styles = useStyles({ classes });

  const localClassName = cx(styles.root, className, {
    [styles.active]: active,
    [styles.completed]: completed,
    [styles.error]: error,
  });

  if (completed) {
    return (
      <SvgIcon
        className={localClassName}
        viewBox="0 0 24 24"
      >
        <circle
          cx="12"
          cy="12"
          r="12"
        />

        <g transform="translate(5, 5) scale(0.6)">
          <path
            d="M20 6L9 17L4 12"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  }

  return (
    <SvgIcon
      className={localClassName}
      viewBox="0 0 24 24"
    >
      <circle
        cx="12"
        cy="12"
        r="12"
      />

      <text
        className={styles.text}
        x="12"
        y="16"
        textAnchor="middle"
      >
        {icon}
      </text>
    </SvgIcon>
  );
};

WizardStepperIcon.propTypes = propTypes;
WizardStepperIcon.defaultProps = defaultProps;

export default WizardStepperIcon;
